import { ReactElement } from 'react';
import { LambdaCapacityProvider } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicDetails } from '../../magic/MagicDetails';

export interface LambdaCapacityProviderDetailsProps {
  data?: Optional<Partial<LambdaCapacityProvider>>;
}

export const LambdaCapacityProviderDetails = ({ data }: LambdaCapacityProviderDetailsProps): ReactElement => (
  <MagicDetails data={data} schema={getSchema('Lambda')} entry="CapacityProvider" title="Capacity Provider Details" />
);
